import type { FC } from "react";
import Required from "../required/Required";

interface LabelProps {
  label: string;
  id: string;
  required?: boolean;
}

const Label: FC<LabelProps> = ({ label, id, required }) => {
  return (
    <label
      htmlFor={id}
      className="flex flex-row gap-x-1 text-[14px] leading-[16px] text-ib-pt-color-neutral-800"
    >
      <span>{label}</span>
      {required && <Required />}
    </label>
  );
};

export default Label;
